"use strict";

var _excluded = ["label"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function () {
  // =============================================================================================
  // WAVE 4b / PART B + C — ACCOUNTS, ADMIN APPROVAL, ENTITLEMENTS, RESTRICTED CONTENT
  // ---------------------------------------------------------------------------------------------
  // THE ONE RULE THIS FILE MUST NEVER BREAK (requirement B4):
  //   The app is fully usable with NO account. Nothing here may block, prompt, redirect, throw,
  //   or log noise. Sign-in gates RESTRICTED CONTENT and SAVING YOUR OWN SCENARIOS (My scenarios)
  //   only. Every other feature — all 254
  //   scenarios, Quick Sim, the monitor, the defibrillator, the debrief — works signed out, and
  //   works identically whether or not Firebase Authentication has even been enabled in the
  //   console. Requirement C4: until auth is enabled, the restricted section must simply read as
  //   locked, with no errors and no broken UI.
  //
  // HOW THAT IS ACHIEVED:
  //   * Auth is resolved ONCE, lazily, inside try/catch into `authAvailable`. If the compat auth
  //     SDK is absent, or the project has no auth configured, we degrade to available:false and
  //     every UI path renders the "locked / not configured" state instead of erroring.
  //   * No network call happens at load beyond onAuthStateChanged, which is free and silent.
  //   * Every RTDB read/write below is .catch()ed. A PERMISSION_DENIED from the rules is an
  //     EXPECTED outcome (that is the enforcement working), so it is swallowed into state rather
  //     than thrown or console.error'd.
  //
  // DATA MODEL (users/{uid}) — see database.rules.json for the matching security rules:
  //   {
  //     email: 'a@b.com',
  //     displayName: 'Dr A B',
  //     createdAt: 1758556800000,
  //     lastSeenAt: 1758556800000,
  //     status: 'pending' | 'approved' | 'rejected',     // ADMIN-WRITE-ONLY
  //     role:   'user' | 'admin',                        // ADMIN-WRITE-ONLY
  //     entitlements: { rcuk: false, etc: false, premium: false, expiresAt: null },   // ADMIN-WRITE-ONLY
  //     requestedAccess: { rcuk: true, at: 1758556800000 }                // user-writable, no privilege
  //   }
  // Access is an ENTITLEMENTS MAP, never a single boolean, so a paid tier is a new key
  // (`premium`, `institution`, ...) rather than a rewrite. `expiresAt` is a ms epoch or null.
  // =============================================================================================

  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect,
    useCallback = _React.useCallback;

  // ---- ENTITLEMENT KEYS ----------------------------------------------------------------------
  // Declared centrally so the admin panel, the gate and the future payment webhook agree.
  var ENTITLEMENT_KEYS = [{
    key: 'rcuk',
    label: 'ALS and other courses (RCUK)',
    note: 'Unlocks the ALS scenarios and any course without its own access (not ETC or CABC).'
  }, {
    key: 'etc',
    label: 'ETC',
    note: 'Unlocks the ETC (European Trauma Course) scenarios and their images.'
  }, {
    key: 'cabc',
    label: 'CABC',
    note: 'Unlocks the CABC course scenarios and their images.'
  }, {
    key: 'premium',
    label: 'Premium (future paid tier)',
    note: 'Reserved. Not sold yet; no payment path is connected.'
  }];
  var DEFAULT_ENTITLEMENTS = {
    rcuk: false,
    etc: false,
    cabc: false,
    premium: false,
    expiresAt: null
  };

  // ---- COURSE ACCESS -------------------------------------------------------------------------
  // Each course is released separately, because different people are entitled to each. A course
  // has its own entitlement key and its own place in the database, and database.rules.json lets
  // only accounts holding that key read it. Scenarios are routed by their `course` field: ETC to
  // courseScenarios/etc, CABC to courseScenarios/cabc, everything else (ALS and older uploads) to
  // restrictedScenarios. A new course needs only a line here: the courseScenarios/$course rule
  // already covers any key.
  var COURSE_ACCESS = [{
    key: 'rcuk',
    name: 'ALS and other courses',
    "short": 'ALS',
    path: 'restrictedScenarios',
    images: null
  }, {
    key: 'etc',
    name: 'ETC (European Trauma Course)',
    "short": 'ETC',
    path: 'courseScenarios/etc',
    images: 'courseImages/etc'
  }, {
    key: 'cabc',
    name: 'CABC',
    "short": 'CABC',
    path: 'courseScenarios/cabc',
    images: 'courseImages/cabc'
  }];
  var courseKeyFor = function courseKeyFor(sc) {
    var c = String(sc && sc.course || '').trim().toUpperCase();
    var own = COURSE_ACCESS.find(function (x) {
      return x.key !== 'rcuk' && x["short"].toUpperCase() === c;
    });
    return own ? own.key : 'rcuk';
  };
  window.COURSE_ACCESS = COURSE_ACCESS;
  window.courseKeyFor = courseKeyFor;

  // ---- LAZY, SILENT AUTH RESOLUTION ----------------------------------------------------------
  // The sign-in SDK (~180 KB) is fetched on demand from window.FIREBASE_AUTH_SRC: when someone
  // signs in, or at start-up when this browser has signed in before (so a returning account is
  // restored without asking). Monitors and defib tablets never fetch it.
  var AUTH_FLAG = 'wmebem_auth_used'; // '1' signed in before, '0' signed out
  var _auth = null;
  var _authError = null;
  var _sdkFailed = false;
  var _sdkPromise = null;
  var sdkPresent = function sdkPresent() {
    return !!(window.firebase && typeof window.firebase.auth === 'function');
  };
  var canLoadSdk = function canLoadSdk() {
    return sdkPresent() || !!(window.firebase && window.FIREBASE_AUTH_SRC);
  };
  var loadAuthSdk = function loadAuthSdk() {
    if (sdkPresent()) return Promise.resolve(true);
    if (_sdkPromise) return _sdkPromise;
    if (!canLoadSdk()) {
      _sdkFailed = true;
      _authError = 'not-loaded';
      return Promise.resolve(false);
    }
    _sdkPromise = new Promise(function (resolve) {
      var el = document.createElement('script');
      el.src = window.FIREBASE_AUTH_SRC;
      el.async = true;
      el.onload = function () {
        if (!sdkPresent()) {
          _sdkFailed = true;
          _authError = 'not-loaded';
        }
        resolve(sdkPresent());
      };
      el.onerror = function () {
        _sdkFailed = true;
        _authError = 'not-loaded';
        resolve(false);
      };
      document.head.appendChild(el);
    });
    return _sdkPromise;
  };
  var setAuthFlag = function setAuthFlag(v) {
    try {
      localStorage.setItem(AUTH_FLAG, v);
    } catch (e) {}
  };

  // A Google pop-up is not dependable in the installed app (the Android app, or the site added
  // to a home screen): on an iPhone home-screen app Firebase cannot even see the window, so it
  // waits for ever. There the page goes to Google and comes back instead. This flag (per tab)
  // marks a sign-in on its way back.
  var REDIRECT_FLAG = 'wmebem_google_redirect';
  var redirectPending = function redirectPending() {
    try {
      return sessionStorage.getItem(REDIRECT_FLAG) === '1';
    } catch (e) {
      return false;
    }
  };
  var setRedirectPending = function setRedirectPending(on) {
    try {
      on ? sessionStorage.setItem(REDIRECT_FLAG, '1') : sessionStorage.removeItem(REDIRECT_FLAG);
    } catch (e) {}
  };
  // Read once as the page loads: only a page that has just come back from Google asks for the
  // result (asking on the page that is about to leave would clear the flag too early).
  var _backFromGoogle = redirectPending();
  var INSTALLED_FLAG = 'wmebem_installed_app';
  var isInstalledApp = function isInstalledApp() {
    try {
      if (String(document.referrer || '').indexOf('android-app://') === 0) sessionStorage.setItem(INSTALLED_FLAG, '1');
      if (sessionStorage.getItem(INSTALLED_FLAG) === '1') return true;
    } catch (e) {}
    try {
      if (window.navigator && window.navigator.standalone === true) return true;
    } catch (e) {}
    try {
      if (window.matchMedia && (window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches)) return true;
    } catch (e) {}
    return false;
  };
  window.__isInstalledApp = isInstalledApp;
  // Has this browser signed in before? Our own flag first; for accounts from before the flag
  // existed, Firebase's own persisted-session storage.
  var signedInBefore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var f, i, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!_backFromGoogle) {
              _context.n = 1;
              break;
            }
            return _context.a(2, true);
          case 1:
            _context.p = 1;
            f = localStorage.getItem(AUTH_FLAG);
            if (!(f === '1')) {
              _context.n = 2;
              break;
            }
            return _context.a(2, true);
          case 2:
            if (!(f === '0')) {
              _context.n = 3;
              break;
            }
            return _context.a(2, false);
          case 3:
            i = 0;
          case 4:
            if (!(i < localStorage.length)) {
              _context.n = 6;
              break;
            }
            if (!(String(localStorage.key(i)).indexOf('firebase:authUser:') === 0)) {
              _context.n = 5;
              break;
            }
            return _context.a(2, true);
          case 5:
            i++;
            _context.n = 4;
            break;
          case 6:
            _context.n = 8;
            break;
          case 7:
            _context.p = 7;
            _t = _context.v;
          case 8:
            _context.p = 8;
            if (!(window.indexedDB && indexedDB.databases)) {
              _context.n = 10;
              break;
            }
            _context.n = 9;
            return indexedDB.databases();
          case 9:
            return _context.a(2, _context.v.some(function (d) {
              return d && d.name === 'firebaseLocalStorageDb';
            }));
          case 10:
            _context.n = 12;
            break;
          case 11:
            _context.p = 11;
            _t2 = _context.v;
          case 12:
            return _context.a(2, false);
        }
      }, _callee, null, [[8, 11], [1, 7]]);
    }));
    return function signedInBefore() {
      return _ref.apply(this, arguments);
    };
  }();
  var getAuth = function getAuth() {
    if (_auth) return _auth;
    if (!sdkPresent()) return null;
    try {
      _auth = window.firebase.auth();
      return _auth;
    } catch (e) {
      // Deliberately NOT console.error: an un-configured project is a supported state
      // (requirement C4 — no console noise), not a bug.
      _authError = 'unavailable';
      _sdkFailed = true;
      return null;
    }
  };

  // Friendly, non-alarming copy for every compat error code we can actually hit. Anything
  // unmapped falls back to the raw message, which is better than a blank box.
  var AUTH_MESSAGES = {
    'auth/operation-not-allowed': 'Email/password sign-in is not switched on for this project yet. See database.rules.json step 1.',
    'auth/configuration-not-found': 'Firebase Authentication has not been set up for this project yet. See database.rules.json step 1.',
    'auth/invalid-email': 'That does not look like a valid email address.',
    'auth/missing-password': 'Please enter a password.',
    'auth/weak-password': 'Please use a password of at least 6 characters.',
    'auth/email-already-in-use': 'There is already an account with that email. Try signing in instead.',
    'auth/user-not-found': 'No account found with that email.',
    'auth/wrong-password': 'Incorrect password.',
    'auth/invalid-credential': 'Incorrect email or password.',
    'auth/invalid-login-credentials': 'Incorrect email or password.',
    'auth/too-many-requests': 'Too many attempts. Please wait a minute and try again.',
    'auth/network-request-failed': 'Could not reach Firebase. Check the network connection.',
    'auth/popup-blocked': 'The Google sign-in window was blocked. Use the button below to sign in with Google in this window instead.',
    'auth/operation-not-supported-in-this-environment': 'Google sign-in cannot open a window here. Use the button below to sign in with Google in this window instead.',
    'auth/web-storage-unsupported': 'This browser is blocking the storage Google sign-in needs (often private browsing). Try a normal browser window, or sign in with email.',
    'auth/redirect-cancelled-by-user': 'Sign-in was cancelled.',
    'auth/user-cancelled': 'Sign-in was cancelled.',
    'auth/internal-error': 'Google sign-in did not finish. Please try again.',
    'auth/popup-closed-by-user': 'Sign-in was cancelled.',
    'auth/cancelled-popup-request': 'Sign-in was cancelled.',
    'auth/account-exists-with-different-credential': 'There is already an account with this email. Sign in with your email and password instead.',
    'auth/unauthorized-domain': 'Google sign-in is not allowed on this web address yet. The owner needs to add it under Firebase → Authentication → Settings → Authorised domains.',
    'google/not-enabled': 'Google sign-in is not switched on for this project yet. The owner can turn it on under Firebase → Authentication → Sign-in method → Google.'
  };
  var describeAuthError = function describeAuthError(e) {
    if (!e) return null;
    return AUTH_MESSAGES[e.code] || e.message || 'Sign-in failed.';
  };
  var normaliseEntitlements = function normaliseEntitlements(raw) {
    var out = _objectSpread({}, DEFAULT_ENTITLEMENTS);
    if (raw && _typeof(raw) === 'object') {
      Object.keys(raw).forEach(function (k) {
        out[k] = raw[k];
      });
    }
    // An expired entitlement is not an entitlement. Enforced client-side for the UI; the DB
    // rules are the real gate, and a server-side expiry sweep would own this properly later.
    var exp = Number(out.expiresAt);
    if (Number.isFinite(exp) && exp > 0 && exp < Date.now()) {
      ENTITLEMENT_KEYS.forEach(function (_ref2) {
        var key = _ref2.key;
        out[key] = false;
      });
      out.expired = true;
    }
    return out;
  };
  var normaliseProfile = function normaliseProfile(uid, raw, fallbackEmail) {
    var p = raw && _typeof(raw) === 'object' ? raw : {};
    return {
      uid: uid,
      email: p.email || fallbackEmail || null,
      displayName: p.displayName || null,
      createdAt: p.createdAt || null,
      lastSeenAt: p.lastSeenAt || null,
      status: p.status === 'approved' || p.status === 'rejected' ? p.status : 'pending',
      role: p.role === 'admin' ? 'admin' : 'user',
      entitlements: normaliseEntitlements(p.entitlements),
      requestedAccess: p.requestedAccess && _typeof(p.requestedAccess) === 'object' ? p.requestedAccess : null
    };
  };
  window.normaliseAuthProfile = normaliseProfile;
  window.normaliseEntitlements = normaliseEntitlements;
  window.ENTITLEMENT_KEYS = ENTITLEMENT_KEYS;
  window.DEFAULT_ENTITLEMENTS = DEFAULT_ENTITLEMENTS;

  // Single source of truth for "may this account see restricted content?". The DB rules mirror
  // this exactly (approved + matching entitlement). Client-side it controls the UI only.
  // An entitlement grants access only when ALL THREE hold: the account is approved, the specific
  // key is true, and the (optional) expiry is in the future. `expiresAt` is what a paid licence
  // will set, so it has to be honoured here from the outset rather than bolted on later, otherwise
  // a lapsed licence would keep working until someone remembered to revoke it by hand.
  // `expiresAt: null` means "no expiry", which is the default for a manually granted entitlement.
  var entitlementsExpired = function entitlementsExpired(ent) {
    var at = ent && ent.expiresAt;
    if (at === null || at === undefined || at === '' || at === false) return false;
    var t = Number(at);
    if (!Number.isFinite(t) || t <= 0) return false; // unparseable expiry is treated as "none"
    return t <= Date.now();
  };
  var hasEntitlement = function hasEntitlement(profile, key) {
    return !!(profile && profile.status === 'approved' && profile.entitlements && profile.entitlements[key] === true && !entitlementsExpired(profile.entitlements));
  };
  window.__entitlementsExpired = entitlementsExpired;
  window.hasEntitlement = hasEntitlement;

  // =============================================================================================
  // useAuth() — the hook every screen uses. Safe to call when auth is unavailable.
  // =============================================================================================
  var useAuth = function useAuth() {
    var _useState = useState(function () {
        return sdkPresent();
      }),
      _useState2 = _slicedToArray(_useState, 2),
      sdkReady = _useState2[0],
      setSdkReady = _useState2[1];
    var _useState3 = useState(function () {
        return {
          // 'idle' while the SDK has not been fetched (nobody has signed in on this browser),
          // 'checking' until onAuthStateChanged fires once, or 'off' when auth cannot load at
          // all. Never 'error' — an unavailable auth is a normal, supported state.
          phase: sdkPresent() ? getAuth() ? 'checking' : 'off' : canLoadSdk() ? 'idle' : 'off',
          available: sdkPresent() ? !!getAuth() : canLoadSdk(),
          reason: _authError,
          user: null,
          profile: null,
          busy: false,
          // true while a Google pop-up is open: the Google button then offers to cancel, so a
          // window that never reports back cannot leave the box stuck on "Working…".
          googlePending: false,
          // true after a pop-up was blocked or is not possible here: offer the same-window way.
          offerRedirect: false,
          error: null,
          notice: null
        };
      }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

    // Returning accounts: fetch the SDK at start-up so the session is restored (never on the
    // room monitor, which has no use for an account).
    useEffect(function () {
      if (sdkReady) return;
      var gone = false;
      var monitor = false;
      try {
        monitor = new URLSearchParams(window.location.search).get('mode') === 'monitor';
      } catch (e) {}
      if (monitor) return;
      signedInBefore().then(function (before) {
        if (!before || gone) return;
        setState(function (s) {
          return _objectSpread(_objectSpread({}, s), {}, {
            phase: 'checking'
          });
        });
        return loadAuthSdk().then(function (ok) {
          if (gone) return;
          if (ok && getAuth()) setSdkReady(true);else setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              phase: 'off',
              available: false,
              reason: _authError
            });
          });
        });
      });
      return function () {
        gone = true;
      };
    }, []);
    useEffect(function () {
      if (!sdkReady) return;
      var auth = getAuth();
      if (!auth) return;
      var profileRef = null;
      var profileHandler = null;
      var cancelled = false;
      var detachProfile = function detachProfile() {
        if (profileRef && profileHandler) {
          try {
            profileRef.off('value', profileHandler);
          } catch (e) {}
        }
        profileRef = null;
        profileHandler = null;
      };
      var unsub = auth.onAuthStateChanged(function (user) {
        if (cancelled) return;
        detachProfile();
        if (!user) {
          // Leave any error alone: with the SDK fetched on demand, this first "nobody
          // signed in" callback can land just after a failed first attempt.
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              phase: 'signedOut',
              user: null,
              profile: null
            });
          });
          return;
        }
        setAuthFlag('1');
        var summary = {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName
        };
        setRedirectPending(false);
        setState(function (s) {
          return _objectSpread(_objectSpread({}, s), {}, {
            phase: 'signedIn',
            user: summary,
            error: null,
            busy: false,
            googlePending: false,
            offerRedirect: false
          });
        });
        var db = window.db;
        if (!db) {
          // Auth without a database: still signed in, just no profile/entitlements.
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              profile: normaliseProfile(user.uid, null, user.email)
            });
          });
          return;
        }
        // Create-if-absent, then live-subscribe. The create writes ONLY profile fields —
        // never role/status/entitlements, which the rules forbid the user from writing.
        profileRef = db.ref("users/".concat(user.uid));
        profileRef.once('value').then(function (snap) {
          if (cancelled) return;
          if (!snap.exists()) {
            return profileRef.update({
              email: user.email || '',
              // A brand-new account's chosen name: the profile write races signUp's own,
              // and updateProfile() has not always landed yet, so use the name typed.
              displayName: user.displayName || window.__pendingSignupName || (user.email ? String(user.email).split('@')[0] : 'User'),
              createdAt: Date.now(),
              lastSeenAt: Date.now()
            })["catch"](function () {});
          }
          return profileRef.child('lastSeenAt').set(Date.now())["catch"](function () {});
        })["catch"](function () {});
        profileHandler = profileRef.on('value', function (snap) {
          if (cancelled) return;
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              profile: normaliseProfile(user.uid, snap.val(), user.email)
            });
          });
        }, function () {
          // PERMISSION_DENIED here means the rules are doing their job. Fall back to a
          // pending, entitlement-free profile rather than surfacing an error.
          if (cancelled) return;
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              profile: normaliseProfile(user.uid, null, user.email)
            });
          });
        });
      }, function () {
        if (cancelled) return;
        setState(function (s) {
          return _objectSpread(_objectSpread({}, s), {}, {
            phase: 'off',
            available: false,
            reason: 'unavailable'
          });
        });
      });

      // Back from Google in the same window: success arrives through onAuthStateChanged
      // above; a failure is only reported here, so keep it for the sign-in box.
      if (_backFromGoogle && typeof auth.getRedirectResult === 'function') {
        _backFromGoogle = false;
        auth.getRedirectResult().then(function () {
          setRedirectPending(false);
        })["catch"](function (e) {
          setRedirectPending(false);
          if (cancelled) return;
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              busy: false,
              googlePending: false,
              error: describeAuthError(e),
              notice: null,
              redirectFailed: true
            });
          });
        });
      }
      return function () {
        cancelled = true;
        detachProfile();
        try {
          unsub();
        } catch (e) {}
      };
    }, [sdkReady]);
    var run = useCallback(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fn, successNotice) {
        var loaded, auth, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: true,
                  googlePending: false,
                  offerRedirect: false,
                  error: null,
                  notice: null
                });
              });
              _context2.n = 1;
              return loadAuthSdk();
            case 1:
              loaded = _context2.v;
              auth = loaded ? getAuth() : null;
              if (auth) {
                _context2.n = 2;
                break;
              }
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: false,
                  phase: 'off',
                  available: false,
                  reason: _authError,
                  error: _authError === 'not-loaded' ? AUTH_MESSAGES['auth/network-request-failed'] : AUTH_MESSAGES['auth/configuration-not-found']
                });
              });
              return _context2.a(2, false);
            case 2:
              setSdkReady(true);
              _context2.p = 3;
              _context2.n = 4;
              return fn(auth);
            case 4:
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: false,
                  error: null,
                  notice: successNotice || null
                });
              });
              return _context2.a(2, true);
            case 5:
              _context2.p = 5;
              _t3 = _context2.v;
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: false,
                  error: describeAuthError(_t3),
                  notice: null
                });
              });
              return _context2.a(2, false);
          }
        }, _callee2, null, [[3, 5]]);
      }));
      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }(), []);
    var signIn = useCallback(function (email, password) {
      return run(function (auth) {
        return auth.signInWithEmailAndPassword(String(email || '').trim(), String(password || ''));
      });
    }, [run]);
    var signUp = useCallback(function (email, password, displayName) {
      return run(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(auth) {
          var name, cred, _t4, _t5;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                name = String(displayName || '').trim();
                window.__pendingSignupName = name || null;
                _context3.n = 1;
                return auth.createUserWithEmailAndPassword(String(email || '').trim(), String(password || ''));
              case 1:
                cred = _context3.v;
                if (!(name && cred.user && cred.user.updateProfile)) {
                  _context3.n = 5;
                  break;
                }
                _context3.p = 2;
                _context3.n = 3;
                return cred.user.updateProfile({
                  displayName: name
                });
              case 3:
                _context3.n = 5;
                break;
              case 4:
                _context3.p = 4;
                _t4 = _context3.v;
              case 5:
                if (!(window.db && cred.user)) {
                  _context3.n = 9;
                  break;
                }
                _context3.p = 6;
                _context3.n = 7;
                return window.db.ref("users/".concat(cred.user.uid)).update({
                  email: cred.user.email || '',
                  displayName: String(name || (cred.user.email ? String(cred.user.email).split('@')[0] : 'User')).slice(0, 119),
                  // the rules cap it at 120; over that the whole profile write was silently rejected
                  createdAt: Date.now(),
                  lastSeenAt: Date.now()
                });
              case 7:
                _context3.n = 9;
                break;
              case 8:
                _context3.p = 8;
                _t5 = _context3.v;
              case 9:
                return _context3.a(2);
            }
          }, _callee3, null, [[6, 8], [2, 4]]);
        }));
        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    }, [run]);
    var resetPassword = useCallback(function (email) {
      return run(function (auth) {
        return auth.sendPasswordResetEmail(String(email || '').trim());
      }, 'Password reset email sent. Check your inbox (and spam).');
    }, [run]);

    // Signs in, or creates the account on first use (the profile is written by the
    // onAuthStateChanged handler above, as for any sign-in). If the Google provider is not
    // enabled in the console, or this web address is not an authorised domain, it fails with a
    // message saying which, and nothing else changes.
    //
    // In a browser tab Google opens in a pop-up, so the page (and anything typed in the
    // Builder) stays as it is. In the installed app, or when asked (`sameWindow`, offered after
    // a pop-up was blocked), the page goes to Google and comes back signed in.
    var googleAttempt = React.useRef(0);
    var signInWithGoogle = useCallback(/*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(opts) {
        var sameWindow, attempt, loaded, auth, provider, e, code, _t6;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              sameWindow = !!(opts && opts.sameWindow === true) || isInstalledApp();
              attempt = ++googleAttempt.current;
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: true,
                  googlePending: !sameWindow,
                  offerRedirect: false,
                  error: null,
                  notice: null
                });
              });
              _context4.n = 1;
              return loadAuthSdk();
            case 1:
              loaded = _context4.v;
              auth = loaded ? getAuth() : null;
              if (!(attempt !== googleAttempt.current)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, false);
            case 2:
              if (auth) {
                _context4.n = 3;
                break;
              }
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: false,
                  googlePending: false,
                  phase: 'off',
                  available: false,
                  reason: _authError,
                  error: _authError === 'not-loaded' ? AUTH_MESSAGES['auth/network-request-failed'] : AUTH_MESSAGES['auth/configuration-not-found']
                });
              });
              return _context4.a(2, false);
            case 3:
              setSdkReady(true);
              _context4.p = 4;
              if (window.firebase.auth.GoogleAuthProvider) {
                _context4.n = 5;
                break;
              }
              throw {
                code: 'google/not-enabled'
              };
            case 5:
              provider = new window.firebase.auth.GoogleAuthProvider();
              if (provider.setCustomParameters) provider.setCustomParameters({
                prompt: 'select_account'
              });
              if (!sameWindow) {
                _context4.n = 7;
                break;
              }
              setRedirectPending(true);
              _context4.n = 6;
              return auth.signInWithRedirect(provider);
            case 6:
              return _context4.a(2, true);
            case 7:
              _context4.n = 8;
              return auth.signInWithPopup(provider);
            case 8:
              if (attempt === googleAttempt.current) setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: false,
                  googlePending: false,
                  error: null
                });
              });
              return _context4.a(2, true);
            case 9:
              _context4.p = 9;
              _t6 = _context4.v;
              if (sameWindow) setRedirectPending(false);
              e = _t6 && _t6.code === 'auth/operation-not-allowed' ? {
                code: 'google/not-enabled'
              } : _t6;
              if (!(attempt !== googleAttempt.current)) {
                _context4.n = 10;
                break;
              }
              return _context4.a(2, false);
            case 10:
              // cancelled meanwhile
              code = e && e.code;
              setState(function (s) {
                return _objectSpread(_objectSpread({}, s), {}, {
                  busy: false,
                  googlePending: false,
                  error: describeAuthError(e),
                  notice: null,
                  offerRedirect: !sameWindow && (code === 'auth/popup-blocked' || code === 'auth/operation-not-supported-in-this-environment')
                });
              });
              return _context4.a(2, false);
          }
        }, _callee4, null, [[4, 9]]);
      }));
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }(), []);

    // Gives up waiting for the Google pop-up. If it does finish later, onAuthStateChanged
    // still signs the account in.
    var cancelGoogle = useCallback(function () {
      googleAttempt.current++;
      setState(function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          busy: false,
          googlePending: false,
          error: null,
          notice: null
        });
      });
    }, []);

    // Signing out also drops the on-device resume snapshot, which carries the whole scenario
    // (restricted course content and mark schemes included) for whoever uses this PC next.
    var signOut = useCallback(function () {
      return run(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(auth) {
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                _context5.n = 1;
                return auth.signOut();
              case 1:
                setAuthFlag('0');
                try {
                  localStorage.removeItem('wmebem_sim_state');
                } catch (e) {}
              case 2:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x5) {
          return _ref6.apply(this, arguments);
        };
      }());
    }, [run]);

    // Asking is not granting. This writes to users/{uid}/requestedAccess, which carries no
    // privilege at all — the admin panel reads it to build the approval queue.
    var requestAccess = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var key,
        uid,
        _args6 = arguments,
        _t7;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            key = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : 'rcuk';
            uid = state.user && state.user.uid;
            if (!(!uid || !window.db)) {
              _context6.n = 1;
              break;
            }
            setState(function (s) {
              return _objectSpread(_objectSpread({}, s), {}, {
                error: 'Sign in first to request access.'
              });
            });
            return _context6.a(2, false);
          case 1:
            _context6.p = 1;
            _context6.n = 2;
            return window.db.ref("users/".concat(uid, "/requestedAccess")).update(_defineProperty(_defineProperty({}, key, true), "at", Date.now()));
          case 2:
            setState(function (s) {
              return _objectSpread(_objectSpread({}, s), {}, {
                notice: 'Access request recorded. You will be notified once it is approved.',
                error: null
              });
            });
            return _context6.a(2, true);
          case 3:
            _context6.p = 3;
            _t7 = _context6.v;
            setState(function (s) {
              return _objectSpread(_objectSpread({}, s), {}, {
                error: 'Could not record the request. The database rules may not be published yet.'
              });
            });
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    })), [state.user]);
    var clearFeedback = useCallback(function () {
      return setState(function (s) {
        return _objectSpread(_objectSpread({}, s), {}, {
          error: null,
          notice: null,
          offerRedirect: false,
          redirectFailed: false
        });
      });
    }, []);
    return _objectSpread(_objectSpread({}, state), {}, {
      isAdmin: !!(state.profile && state.profile.role === 'admin'),
      entitlements: state.profile && state.profile.entitlements || _objectSpread({}, DEFAULT_ENTITLEMENTS),
      has: function has(key) {
        return hasEntitlement(state.profile, key);
      },
      signIn: signIn,
      signUp: signUp,
      signOut: signOut,
      resetPassword: resetPassword,
      signInWithGoogle: signInWithGoogle,
      cancelGoogle: cancelGoogle,
      requestAccess: requestAccess,
      clearFeedback: clearFeedback
    });
  };
  window.useAuth = useAuth;

  // =============================================================================================
  // MY SCENARIOS — custom scenarios saved to the signed-in account
  // ---------------------------------------------------------------------------------------------
  // Scenarios built in the Builder or imported from a file live at userScenarios/{uid}/{id}, and
  // the rules let only that account read or write them. Saving needs an account; running a
  // built-in scenario, or running a Builder scenario without saving it, does not.
  // Before accounts held them they lived in this browser's localStorage (LEGACY_KEY). Those are
  // still listed on this device and can be added to the account once signed in; a different web
  // address (the custom domain) cannot see them at all, which is why the account is the home now.
  // =============================================================================================
  var LEGACY_KEY = 'wmebem_custom_scenarios';
  var MAX_USER_SCENARIOS = 200;
  // Firebase keys cannot contain . # $ [ ] / and the rules cap the length.
  var safeKey = function safeKey(id) {
    return typeof id === 'string' && id.length > 0 && id.length <= 100 && !/[.#$\[\]\/\u0000-\u001f\u007f]/.test(id);
  };
  var isScenario = function isScenario(s) {
    return !!s && _typeof(s) === 'object' && !Array.isArray(s) && typeof s.id === 'string' && s.id.length > 0 && typeof s.title === 'string' && s.title.length > 0;
  };
  // Through JSON: drops undefined and functions, which Firebase refuses to store.
  var forStorage = function forStorage(s) {
    var c = JSON.parse(JSON.stringify(s));
    c.title = String(c.title).slice(0, 200);
    return c;
  };
  // A scenario whose id cannot be a database key gets a CUST_ id made from the old one rather than
  // being refused. The same old id always gives the same new id, so importing a file twice (or
  // adding this device's scenarios twice) skips the ones already there instead of copying them.
  var hashId = function hashId(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = (h * 33 ^ str.charCodeAt(i)) >>> 0;
    return h.toString(36);
  };
  var withSafeId = function withSafeId(s) {
    return safeKey(s.id) ? s : _objectSpread(_objectSpread({}, s), {}, {
      id: "CUST_".concat(hashId(String(s.id)))
    });
  };
  // set() and update() THROW (rather than reject) on a key Firebase forbids anywhere inside the
  // scenario; make that a rejection so the caller's message is shown.
  var write = function write(fn) {
    try {
      return Promise.resolve(fn());
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var listFrom = function listFrom(raw) {
    if (!raw || _typeof(raw) !== 'object') return [];
    return Object.keys(raw).map(function (k) {
      return raw[k];
    }).filter(isScenario).sort(function (a, b) {
      return (Number(a.savedAt) || 0) - (Number(b.savedAt) || 0) || a.title.localeCompare(b.title);
    });
  };
  var UserScenarios = {
    LEGACY_KEY: LEGACY_KEY,
    MAX: MAX_USER_SCENARIOS,
    isScenario: isScenario,
    safeKey: safeKey,
    // Live list for one account. onList gets an array; onError gets 'denied' or 'unavailable'.
    subscribe: function subscribe(uid, onList, onError) {
      if (!uid || !window.db) {
        if (onError) onError('unavailable');
        return function () {};
      }
      var ref = window.db.ref("userScenarios/".concat(uid));
      var handler = ref.on('value', function (snap) {
        var list = listFrom(snap.val());
        UserScenarios.cache = list;
        onList(list);
      }, function (e) {
        if (onError) onError(/permission|denied/i.test(String(e && e.message || '')) ? 'denied' : 'unavailable');
      });
      return function () {
        try {
          ref.off('value', handler);
        } catch (e) {}
      };
    },
    save: function save(uid, scenario) {
      if (!uid || !window.db) return Promise.reject(new Error('Sign in to save scenarios.'));
      if (!isScenario(scenario)) return Promise.reject(new Error('A scenario needs an id and a title.'));
      var s = withSafeId(forStorage(scenario));
      s.savedAt = Date.now();
      return write(function () {
        return window.db.ref("userScenarios/".concat(uid, "/").concat(s.id)).set(s);
      }).then(function () {
        return s;
      });
    },
    // Several at once (file import, moving this device's scenarios in). Ids already in the
    // account are skipped, never overwritten. Resolves to the number added.
    saveMany: function saveMany(uid, list, existing) {
      if (!uid || !window.db) return Promise.reject(new Error('Sign in to save scenarios.'));
      var have = new Set((existing || []).map(function (s) {
        return s.id;
      }));
      var room = Math.max(0, MAX_USER_SCENARIOS - have.size);
      var updates = {};
      var n = 0;
      (list || []).filter(isScenario).forEach(function (raw) {
        if (n >= room || have.has(raw.id)) return;
        var s = withSafeId(forStorage(raw));
        if (have.has(s.id)) return;
        s.savedAt = Date.now() + n;
        updates[s.id] = s;
        have.add(s.id);
        n++;
      });
      if (!n) return Promise.resolve(0);
      return write(function () {
        return window.db.ref("userScenarios/".concat(uid)).update(updates);
      }).then(function () {
        return n;
      });
    },
    remove: function remove(uid, id) {
      if (!uid || !window.db || !safeKey(id)) return Promise.reject(new Error('Sign in to delete scenarios.'));
      return window.db.ref("userScenarios/".concat(uid, "/").concat(id)).remove();
    },
    // Scenarios saved in this browser before accounts held them.
    readLegacy: function readLegacy() {
      try {
        var raw = localStorage.getItem(LEGACY_KEY);
        if (!raw) return [];
        var parsed = JSON.parse(raw);
        return (Array.isArray(parsed) ? parsed : [parsed]).filter(isScenario);
      } catch (e) {
        return [];
      }
    },
    clearLegacy: function clearLegacy() {
      try {
        localStorage.removeItem(LEGACY_KEY);
      } catch (e) {}
    },
    // The signed-in account's list as last loaded, so a resumed run can find its scenario.
    cache: []
  };
  window.UserScenarios = UserScenarios;

  // =============================================================================================
  // RESTRICTED SCENARIO LOADER (requirement C2 / C5)
  // ---------------------------------------------------------------------------------------------
  // Restricted scenarios are read from RTDB at `restrictedScenarios/` AT RUNTIME and are never
  // part of the shipped JavaScript bundle — that is the entire point, so copyrighted content is
  // not sitting in a public static file. Once loaded, each entry is put through
  // window.enrichScenario() — the SAME function every built-in scenario goes through — so
  // enrichment, WETFLAG, investigations, defib and deterioration all behave identically with no
  // special-casing anywhere downstream.
  // =============================================================================================
  // `keys` are the course entitlements this account holds (window.COURSE_ACCESS). Each course is
  // read on its own, so a refusal for one (not entitled, rules not yet published) does not hide
  // the other. ETC scenarios uploaded to restrictedScenarios before the courses were split are
  // skipped there: they belong to ETC and the next upload moves them.
  window.loadRestrictedScenarios = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
    var keys,
      wanted,
      scenarios,
      okCount,
      denied,
      _iterator,
      _step,
      _loop,
      _args8 = arguments,
      _t9;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          keys = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : ['rcuk'];
          if (window.db) {
            _context8.n = 1;
            break;
          }
          return _context8.a(2, {
            ok: false,
            reason: 'no-database',
            scenarios: []
          });
        case 1:
          wanted = COURSE_ACCESS.filter(function (c) {
            return keys.includes(c.key);
          });
          scenarios = [];
          okCount = 0, denied = false;
          _iterator = _createForOfIteratorHelper(wanted);
          _context8.p = 2;
          _loop = /*#__PURE__*/_regenerator().m(function _loop() {
            var c, snap, raw, list, _t8;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.p = _context7.n) {
                case 0:
                  c = _step.value;
                  _context7.p = 1;
                  _context7.n = 2;
                  return window.db.ref(c.path).once('value');
                case 2:
                  snap = _context7.v;
                  okCount++;
                  raw = snap.val();
                  if (!(!raw || _typeof(raw) !== 'object')) {
                    _context7.n = 3;
                    break;
                  }
                  return _context7.a(2, 1);
                case 3:
                  list = Array.isArray(raw) ? raw : Object.keys(raw).map(function (k) {
                    var entry = raw[k];
                    if (!entry || _typeof(entry) !== 'object') return null;
                    return _objectSpread(_objectSpread({}, entry), {}, {
                      id: entry.id || k
                    });
                  });
                  list.forEach(function (s) {
                    // Same shape guard the custom-scenario importer uses: an id and a title, or it is
                    // not a scenario and must not reach the list renderer.
                    if (!s || typeof s.id !== 'string' || !s.id || typeof s.title !== 'string' || !s.title) return;
                    if (courseKeyFor(s) !== c.key) return;
                    if (scenarios.some(function (x) {
                      return x.id === s.id;
                    })) return;
                    try {
                      var enriched = window.enrichScenario ? window.enrichScenario(_objectSpread(_objectSpread({}, s), {}, {
                        restricted: true,
                        courseKey: c.key
                      })) : _objectSpread(_objectSpread({}, s), {}, {
                        restricted: true,
                        courseKey: c.key
                      });
                      if (enriched) scenarios.push(enriched);
                    } catch (e) {/* one malformed pasted entry must not take the list down */}
                  });
                  _context7.n = 5;
                  break;
                case 4:
                  _context7.p = 4;
                  _t8 = _context7.v;
                  // PERMISSION_DENIED is the expected, correct answer for an unentitled account. It is a
                  // state, not an error, and must not reach the console (requirement C4).
                  if (/permission|denied/i.test(String(_t8 && _t8.message || ''))) denied = true;
                case 5:
                  return _context7.a(2);
              }
            }, _loop, null, [[1, 4]]);
          });
          _iterator.s();
        case 3:
          if ((_step = _iterator.n()).done) {
            _context8.n = 6;
            break;
          }
          return _context8.d(_regeneratorValues(_loop()), 4);
        case 4:
          if (!_context8.v) {
            _context8.n = 5;
            break;
          }
          return _context8.a(3, 5);
        case 5:
          _context8.n = 3;
          break;
        case 6:
          _context8.n = 8;
          break;
        case 7:
          _context8.p = 7;
          _t9 = _context8.v;
          _iterator.e(_t9);
        case 8:
          _context8.p = 8;
          _iterator.f();
          return _context8.f(8);
        case 9:
          if (okCount) {
            _context8.n = 10;
            break;
          }
          return _context8.a(2, {
            ok: false,
            reason: denied ? 'denied' : 'unavailable',
            scenarios: []
          });
        case 10:
          return _context8.a(2, {
            ok: true,
            reason: scenarios.length ? 'loaded' : 'empty',
            scenarios: scenarios
          });
      }
    }, _callee7, null, [[2, 7, 8, 9]]);
  }));

  // A course image (an X-ray, CT, eFAST or scene photo from the course slides), read when a mark
  // sheet shows it. Same entitlement as the course's scenarios. Cached for the page's lifetime.
  var _courseImageCache = {};
  window.loadCourseImage = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(courseKey, id) {
      var c, k;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            c = COURSE_ACCESS.find(function (x) {
              return x.key === courseKey;
            });
            if (!(!c || !c.images || !id || !window.db)) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2, null);
          case 1:
            k = "".concat(courseKey, "/").concat(id);
            if (!_courseImageCache[k]) {
              _courseImageCache[k] = window.db.ref("".concat(c.images, "/").concat(id)).once('value').then(function (snap) {
                var v = snap.val();
                return v && typeof v.src === 'string' ? v : null;
              })["catch"](function () {
                delete _courseImageCache[k];
                return null;
              });
            }
            return _context9.a(2, _courseImageCache[k]);
        }
      }, _callee8);
    }));
    return function (_x6, _x7) {
      return _ref9.apply(this, arguments);
    };
  }();

  // =============================================================================================
  // PAYMENT SEAM — DELIBERATELY NOT CONNECTED (requirement B6)
  // ---------------------------------------------------------------------------------------------
  // When paid licences are added, DO NOT write entitlements from this file or any other
  // client-side code. The flow must be:
  //
  //   1. Client calls your server to create a checkout session (Stripe, Paddle, GoCardless...).
  //   2. Provider redirects the buyer back to the app. The client learns NOTHING authoritative
  //      from that redirect — it is a hint to re-read users/{uid}, nothing more.
  //   3. The provider's WEBHOOK hits YOUR SERVER. The server verifies the signature, then uses
  //      the Firebase Admin SDK (which bypasses database.rules.json) to write:
  //          users/{uid}/entitlements/premium  = true
  //          users/{uid}/entitlements/expiresAt = <ms epoch>
  //      and appends an audit record under paymentEvents/{eventId}.
  //   4. The client's live `on('value')` subscription above picks the change up automatically —
  //      no extra client code is needed, which is why there is no client hook here.
  //
  // ENTITLEMENTS MUST NEVER BE CLIENT-WRITABLE. database.rules.json enforces that (admin-only
  // .write on users/$uid/entitlements, plus paymentEvents closed to every client in both
  // directions). A client that can write its own entitlements has no paywall at all.
  //
  // The function below exists ONLY to make the seam findable and to fail loudly if someone
  // wires it up client-side by mistake. It is not called from anywhere.
  window.__paymentWebhookSeam = function () {
    throw new Error('Entitlements are server-owned. Write them from a signature-verified webhook using the Firebase Admin SDK — never from the client. See data/auth.js.');
  };

  // =============================================================================================
  // UI — AccountButton (header), AuthModal, AdminPanel
  // =============================================================================================
  var Field = function Field(_ref0) {
    var label = _ref0.label,
      props = _objectWithoutProperties(_ref0, _excluded);
    return /*#__PURE__*/React.createElement("label", {
      className: "block"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] uppercase tracking-wider text-slate-400 font-bold"
    }, label), /*#__PURE__*/React.createElement("input", _extends({}, props, {
      className: "w-full bg-slate-900 border border-slate-600 rounded p-2 text-white text-sm mt-0.5 focus:border-sky-500 outline-none"
    })));
  };
  var AuthModal = function AuthModal(_ref1) {
    var auth = _ref1.auth,
      onClose = _ref1.onClose,
      _ref1$initialTab = _ref1.initialTab,
      initialTab = _ref1$initialTab === void 0 ? 'signin' : _ref1$initialTab,
      _ref1$context = _ref1.context,
      context = _ref1$context === void 0 ? null : _ref1$context;
    var _window = window,
      Button = _window.Button,
      Lucide = _window.Lucide,
      Modal = _window.Modal;
    var _useState5 = useState(initialTab),
      _useState6 = _slicedToArray(_useState5, 2),
      tab = _useState6[0],
      setTab = _useState6[1];
    var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      email = _useState8[0],
      setEmail = _useState8[1];
    var _useState9 = useState(''),
      _useState0 = _slicedToArray(_useState9, 2),
      password = _useState0[0],
      setPassword = _useState0[1];
    var _useState1 = useState(''),
      _useState10 = _slicedToArray(_useState1, 2),
      name = _useState10[0],
      setName = _useState10[1];
    var submit = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (e && e.preventDefault) e.preventDefault();
              if (!(tab === 'signin')) {
                _context0.n = 2;
                break;
              }
              _context0.n = 1;
              return auth.signIn(email, password);
            case 1:
              _context0.n = 5;
              break;
            case 2:
              if (!(tab === 'signup')) {
                _context0.n = 4;
                break;
              }
              _context0.n = 3;
              return auth.signUp(email, password, name);
            case 3:
              _context0.n = 5;
              break;
            case 4:
              _context0.n = 5;
              return auth.resetPassword(email);
            case 5:
              return _context0.a(2);
          }
        }, _callee9);
      }));
      return function submit(_x8) {
        return _ref10.apply(this, arguments);
      };
    }();
    var TABS = [['signin', 'Sign in'], ['signup', 'Create account'], ['reset', 'Reset password']];

    // Once signed in (email, new account or the Google window) the box has done its job: close
    // it so the header shows the account straight away instead of a sign-in form that looks
    // as if nothing happened.
    var signedInNow = auth.phase === 'signedIn' && !!auth.user;
    useEffect(function () {
      if (signedInNow && onClose) onClose();
    }, [signedInNow]);

    // Fetch the sign-in library as the box opens, so tapping "Continue with Google" opens
    // Google's window straight away: a phone browser blocks a window opened after a wait.
    useEffect(function () {
      if (auth.available && canLoadSdk()) loadAuthSdk();
    }, []);
    var installed = isInstalledApp();
    return /*#__PURE__*/React.createElement(Modal, {
      label: "Account",
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-md shadow-2xl"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start mb-3"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Account"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 mt-0.5"
    }, "An account saves your own scenarios so you can use them on any device. Everything else in the app works without one.")), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close account panel",
      onClick: onClose,
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), context && /*#__PURE__*/React.createElement("div", {
      className: "mb-3 text-xs bg-slate-900 border border-slate-700 rounded p-2 text-slate-300"
    }, context), !auth.available ? /*#__PURE__*/React.createElement("div", {
      className: "bg-amber-950/40 border border-amber-600/60 rounded p-3 text-xs text-amber-200 space-y-2"
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-bold uppercase tracking-wider text-[10px]"
    }, "Sign-in not configured yet"), /*#__PURE__*/React.createElement("p", null, "Firebase Authentication has not been enabled for this project, so accounts cannot be created yet. The rest of the simulator is unaffected."), /*#__PURE__*/React.createElement("p", {
      className: "text-amber-300/80"
    }, "Owner: enable Email/Password under Build \u2192 Authentication \u2192 Sign-in method, then publish ", /*#__PURE__*/React.createElement("span", {
      className: "font-mono"
    }, "database.rules.json"), ".")) : /*#__PURE__*/React.createElement("form", {
      onSubmit: submit,
      className: "space-y-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1 border-b border-slate-700 mb-1"
    }, TABS.map(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
        id = _ref12[0],
        label = _ref12[1];
      return /*#__PURE__*/React.createElement("button", {
        key: id,
        type: "button",
        onClick: function onClick() {
          setTab(id);
          auth.clearFeedback();
        },
        className: "pb-2 px-2 text-[11px] font-bold uppercase tracking-wider ".concat(tab === id ? 'text-sky-400 border-b-2 border-sky-400' : 'text-slate-400 hover:text-slate-300')
      }, label);
    })), tab !== 'reset' && /*#__PURE__*/React.createElement(React.Fragment, null, auth.googlePending ? /*#__PURE__*/React.createElement("div", {
      className: "space-y-1"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: auth.cancelGoogle,
      className: "w-full h-11 rounded border border-slate-500 bg-slate-200 text-slate-900 text-sm font-bold hover:bg-white flex items-center justify-center gap-2"
    }, "Waiting for Google\u2026 tap to cancel"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 text-center",
      role: "status"
    }, "Finish signing in in the Google window. If you closed it, tap the button above and try again.")) : /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return auth.signInWithGoogle();
      },
      disabled: auth.busy,
      className: "w-full h-11 rounded border border-slate-500 bg-white text-slate-900 text-sm font-bold hover:bg-slate-100 flex items-center justify-center gap-2 disabled:opacity-60"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      className: "font-black text-base text-sky-600"
    }, "G"), tab === 'signup' ? 'Create account with Google' : 'Continue with Google'), installed && !auth.googlePending && context && /save/i.test(context) && /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-amber-300 text-center"
    }, "In the app, Google sign-in leaves this page briefly, so anything not yet saved is lost. Signing in with email keeps it."), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 text-[10px] uppercase tracking-wider text-slate-400",
      "aria-hidden": "true"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex-1 border-t border-slate-700"
    }), "or use email", /*#__PURE__*/React.createElement("span", {
      className: "flex-1 border-t border-slate-700"
    }))), tab === 'signup' && /*#__PURE__*/React.createElement(Field, {
      label: "Display name",
      type: "text",
      value: name,
      onChange: function onChange(e) {
        return setName(e.target.value);
      },
      placeholder: "Optional",
      autoComplete: "name"
    }), /*#__PURE__*/React.createElement(Field, {
      label: "Email",
      type: "email",
      value: email,
      onChange: function onChange(e) {
        return setEmail(e.target.value);
      },
      autoComplete: "username",
      required: true
    }), tab !== 'reset' && /*#__PURE__*/React.createElement(Field, {
      label: "Password",
      type: "password",
      value: password,
      onChange: function onChange(e) {
        return setPassword(e.target.value);
      },
      autoComplete: tab === 'signup' ? 'new-password' : 'current-password',
      required: true
    }), auth.error && /*#__PURE__*/React.createElement("div", {
      className: "bg-red-950/50 border border-red-600 rounded p-2 text-[11px] text-red-200"
    }, auth.error), auth.offerRedirect && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return auth.signInWithGoogle({
          sameWindow: true
        });
      },
      disabled: auth.busy,
      className: "w-full h-11 rounded border border-sky-500 bg-slate-900 text-sky-200 text-sm font-bold hover:bg-slate-800 disabled:opacity-60"
    }, "Sign in with Google in this window"), auth.notice && /*#__PURE__*/React.createElement("div", {
      className: "bg-emerald-950/50 border border-emerald-600 rounded p-2 text-[11px] text-emerald-200"
    }, auth.notice), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      variant: "primary",
      disabled: auth.busy,
      className: "w-full h-11 font-bold"
    }, auth.busy && !auth.googlePending ? 'Working…' : tab === 'signin' ? 'Sign in' : tab === 'signup' ? 'Create account' : 'Send reset email')), /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outline",
      className: "w-full mt-4"
    }, "Close"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 text-center mt-3"
    }, "How we use your details: ", /*#__PURE__*/React.createElement("a", {
      href: "privacy.html",
      target: "_blank",
      rel: "noopener",
      className: "underline hover:text-white"
    }, "privacy notice"))));
  };

  // ---- COURSE SCENARIO UPLOAD (admin) --------------------------------------------------------
  // Restricted course scenarios (e.g. the ETC pack) are kept OUT of this public repository and
  // uploaded from a JSON file the owner holds. Accepts { "<ID>": scenario, … }, an array of
  // scenarios, { "restrictedScenarios": { … } }, or { "scenarios": { … }, "images": { … } }.
  // Each scenario goes to its course's place (COURSE_ACCESS: ETC to courseScenarios/etc, the
  // rest to restrictedScenarios) with update(), so scenarios already there that are not in the
  // file are left alone, a scenario with the same id is replaced, and a copy of it left in the
  // other course's place is removed. Images (data URLs, one per key, each with a `credit`) go to
  // courseImages/<course>/<id>, one write each: a single write is limited in size.
  var BAD_KEY = /[.#$\[\]\/]/;
  var parseCourseScenarioFile = function parseCourseScenarioFile(text) {
    var raw;
    try {
      raw = JSON.parse(text);
    } catch (e) {
      return {
        error: 'That file is not valid JSON.'
      };
    }
    var rawImages = null;
    if (raw && _typeof(raw) === 'object' && !Array.isArray(raw)) {
      if (raw.images && _typeof(raw.images) === 'object' && !Array.isArray(raw.images)) rawImages = raw.images;
      if (raw.scenarios && _typeof(raw.scenarios) === 'object') raw = raw.scenarios;else if (raw.restrictedScenarios && _typeof(raw.restrictedScenarios) === 'object') raw = raw.restrictedScenarios;
    }
    var list = Array.isArray(raw) ? raw : raw && _typeof(raw) === 'object' ? Object.keys(raw).map(function (k) {
      return raw[k] && _typeof(raw[k]) === 'object' ? _objectSpread(_objectSpread({}, raw[k]), {}, {
        id: raw[k].id || k
      }) : null;
    }) : [];
    var ok = {},
      bad = [];
    list.forEach(function (sc, i) {
      var id = sc && typeof sc.id === 'string' ? sc.id.trim() : '';
      if (!sc || !id || typeof sc.title !== 'string' || !sc.title.trim()) {
        bad.push("item ".concat(i + 1, ": needs an id and a title"));
        return;
      }
      if (BAD_KEY.test(id)) {
        bad.push("".concat(id, ": an id cannot contain . # $ [ ] or /"));
        return;
      }
      if (ok[id]) {
        bad.push("".concat(id, ": appears twice"));
        return;
      }
      // Realtime Database refuses the whole upload if any key, at any depth, has one of these.
      var badKey = function find(v) {
        if (!v || _typeof(v) !== 'object') return null;
        for (var _i = 0, _Object$keys = Object.keys(v); _i < _Object$keys.length; _i++) {
          var k = _Object$keys[_i];
          if (BAD_KEY.test(k)) return k;
          var inner = find(v[k]);
          if (inner) return inner;
        }
        return null;
      }(sc);
      if (badKey) {
        bad.push("".concat(id, ": the field name \"").concat(badKey.slice(0, 40), "\" cannot contain . # $ [ ] or /"));
        return;
      }
      ok[id] = _objectSpread(_objectSpread({}, sc), {}, {
        id: id
      });
    });
    var images = {};
    if (rawImages) Object.keys(rawImages).forEach(function (id) {
      var im = rawImages[id];
      if (BAD_KEY.test(id) || id.length > 100) {
        bad.push("image ".concat(id.slice(0, 40), ": an id cannot contain . # $ [ ] or /"));
        return;
      }
      if (!im || typeof im.src !== 'string' || !/^data:image\/(jpeg|png|webp);base64,/.test(im.src)) {
        bad.push("image ".concat(id, ": needs a JPEG, PNG or WebP data URL"));
        return;
      }
      if (im.src.length > 1000000) {
        bad.push("image ".concat(id, ": larger than 1 MB"));
        return;
      }
      if (typeof im.credit !== 'string' || !im.credit.trim()) {
        bad.push("image ".concat(id, ": needs a credit"));
        return;
      }
      var key = courseKeyFor(im);
      var course = COURSE_ACCESS.find(function (c) {
        return c.key === key;
      });
      if (!course || !course.images) {
        bad.push("image ".concat(id, ": images are only stored for courses with their own access (").concat(COURSE_ACCESS.filter(function (c) {
          return c.images;
        }).map(function (c) {
          return c["short"];
        }).join(', '), ")"));
        return;
      }
      images[id] = {
        key: key,
        value: _objectSpread(_objectSpread({
          src: im.src,
          credit: im.credit.slice(0, 400),
          modality: String(im.modality || '').slice(0, 16)
        }, Number.isFinite(im.w) ? {
          w: im.w
        } : {}), Number.isFinite(im.h) ? {
          h: im.h
        } : {})
      };
    });
    if (!Object.keys(ok).length && !Object.keys(images).length) return {
      error: bad.length ? "No scenarios could be read (".concat(bad.slice(0, 3).join('; '), ").") : 'The file has no scenarios in it.'
    };
    var courses = {};
    Object.values(ok).forEach(function (sc) {
      var c = typeof sc.course === 'string' && sc.course.trim() || 'No course';
      courses[c] = (courses[c] || 0) + 1;
    });
    return {
      scenarios: ok,
      images: images,
      bad: bad,
      courses: courses
    };
  };
  window.parseCourseScenarioFile = parseCourseScenarioFile;

  // Writes a parsed file. `onProgress(done, total)` follows the image writes.
  var uploadCourseFile = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(parsed, onProgress) {
      var byPath, _i2, _Object$keys2, path, ids, _loop2, i;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            byPath = {};
            COURSE_ACCESS.forEach(function (c) {
              byPath[c.path] = {};
            });
            Object.values(parsed.scenarios || {}).forEach(function (sc) {
              var key = courseKeyFor(sc);
              COURSE_ACCESS.forEach(function (c) {
                byPath[c.path][sc.id] = c.key === key ? sc : null;
              });
            });
            _i2 = 0, _Object$keys2 = Object.keys(byPath);
          case 1:
            if (!(_i2 < _Object$keys2.length)) {
              _context10.n = 3;
              break;
            }
            path = _Object$keys2[_i2];
            if (!Object.keys(byPath[path]).length) {
              _context10.n = 2;
              break;
            }
            _context10.n = 2;
            return window.db.ref(path).update(byPath[path]);
          case 2:
            _i2++;
            _context10.n = 1;
            break;
          case 3:
            ids = Object.keys(parsed.images || {});
            _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
              var _parsed$images$ids$i, key, value, course;
              return _regenerator().w(function (_context1) {
                while (1) switch (_context1.n) {
                  case 0:
                    _parsed$images$ids$i = parsed.images[ids[i]], key = _parsed$images$ids$i.key, value = _parsed$images$ids$i.value;
                    course = COURSE_ACCESS.find(function (c) {
                      return c.key === key;
                    });
                    _context1.n = 1;
                    return window.db.ref("".concat(course.images, "/").concat(ids[i])).set(value);
                  case 1:
                    if (onProgress) onProgress(i + 1, ids.length);
                  case 2:
                    return _context1.a(2);
                }
              }, _loop2);
            });
            i = 0;
          case 4:
            if (!(i < ids.length)) {
              _context10.n = 6;
              break;
            }
            return _context10.d(_regeneratorValues(_loop2()), 5);
          case 5:
            i++;
            _context10.n = 4;
            break;
          case 6:
            return _context10.a(2);
        }
      }, _callee0);
    }));
    return function uploadCourseFile(_x9, _x0) {
      return _ref13.apply(this, arguments);
    };
  }();
  window.uploadCourseFile = uploadCourseFile;
  var CourseScenarioUpload = function CourseScenarioUpload() {
    var _window2 = window,
      Button = _window2.Button,
      Lucide = _window2.Lucide;
    var _useState11 = useState(null),
      _useState12 = _slicedToArray(_useState11, 2),
      parsed = _useState12[0],
      setParsed = _useState12[1];
    var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      fileName = _useState14[0],
      setFileName = _useState14[1];
    var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      busy = _useState16[0],
      setBusy = _useState16[1];
    var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      progress = _useState18[0],
      setProgress = _useState18[1];
    var _useState19 = useState(null),
      _useState20 = _slicedToArray(_useState19, 2),
      message = _useState20[0],
      setMessage = _useState20[1];
    var onFile = function onFile(e) {
      var f = e.target.files && e.target.files[0];
      setMessage(null);
      setParsed(null);
      setFileName(f ? f.name : '');
      if (!f) return;
      var reader = new FileReader();
      reader.onload = function () {
        return setParsed(parseCourseScenarioFile(String(reader.result || '')));
      };
      reader.onerror = function () {
        return setParsed({
          error: 'The file could not be read.'
        });
      };
      reader.readAsText(f);
    };
    var count = parsed && parsed.scenarios ? Object.keys(parsed.scenarios).length : 0;
    var imageCount = parsed && parsed.images ? Object.keys(parsed.images).length : 0;
    var upload = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _t0;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              if (!(!parsed || !count && !imageCount || !window.db)) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              setBusy(true);
              setMessage(null);
              setProgress(null);
              _context11.p = 2;
              _context11.n = 3;
              return uploadCourseFile(parsed, function (done, total) {
                return setProgress("".concat(done, " of ").concat(total, " images"));
              });
            case 3:
              setMessage({
                ok: true,
                text: "Uploaded ".concat(count, " scenario").concat(count === 1 ? '' : 's').concat(imageCount ? " and ".concat(imageCount, " image").concat(imageCount === 1 ? '' : 's') : '', ". Reopen Course scenarios to see them.")
              });
              setParsed(null);
              _context11.n = 5;
              break;
            case 4:
              _context11.p = 4;
              _t0 = _context11.v;
              setMessage({
                ok: false,
                text: 'The database refused the upload. Only an admin can write course scenarios: check your own role is "admin" and that database.rules.json is published.'
              });
            case 5:
              setBusy(false);
              setProgress(null);
            case 6:
              return _context11.a(2);
          }
        }, _callee1, null, [[2, 4]]);
      }));
      return function upload() {
        return _ref14.apply(this, arguments);
      };
    }();
    var label = "Upload ".concat(count, " scenario").concat(count === 1 ? '' : 's').concat(imageCount ? " and ".concat(imageCount, " image").concat(imageCount === 1 ? '' : 's') : '');
    return /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 mt-3 pt-3",
      "data-testid": "course-upload"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] font-bold uppercase tracking-wider text-amber-400 mb-1 flex items-center gap-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "upload",
      className: "w-3 h-3"
    }), " Course scenarios"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 mb-2"
    }, "Upload a course scenario file (JSON). ETC and CABC scenarios and images are only readable with access to that course (by their course field); all others with ALS access. Scenarios with the same id are replaced; others already in the database are kept."), /*#__PURE__*/React.createElement("label", {
      className: "inline-flex items-center gap-2 text-xs text-slate-200"
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Course scenario file"), /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: "application/json,.json",
      "aria-label": "Course scenario file",
      onChange: onFile,
      className: "text-xs text-slate-300 file:mr-2 file:rounded file:border file:border-slate-600 file:bg-slate-900 file:px-2 file:py-1 file:text-slate-200"
    })), parsed && parsed.error && /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-red-300 mt-2"
    }, parsed.error), (count > 0 || imageCount > 0) && /*#__PURE__*/React.createElement("div", {
      className: "mt-2 text-[11px] text-slate-300 space-y-1"
    }, /*#__PURE__*/React.createElement("div", null, fileName, ": ", /*#__PURE__*/React.createElement("b", null, count), " scenario", count === 1 ? '' : 's', count ? " (".concat(Object.keys(parsed.courses).map(function (c) {
      return "".concat(c, ": ").concat(parsed.courses[c]);
    }).join(', '), ")") : '', imageCount ? /*#__PURE__*/React.createElement(React.Fragment, null, ", ", /*#__PURE__*/React.createElement("b", null, imageCount), " image", imageCount === 1 ? '' : 's') : null, "."), parsed.bad.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-amber-300"
    }, "Skipped ", parsed.bad.length, ": ", parsed.bad.slice(0, 5).join('; '), parsed.bad.length > 5 ? '…' : ''), /*#__PURE__*/React.createElement(Button, {
      onClick: upload,
      disabled: busy,
      variant: "primary",
      className: "h-8 px-3 text-xs"
    }, busy ? "Uploading\u2026".concat(progress ? " ".concat(progress) : '') : label)), message && /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] mt-2 ".concat(message.ok ? 'text-emerald-300' : 'text-red-300')
    }, message.text));
  };

  // ---- ADMIN PANEL (requirement B3) ----------------------------------------------------------
  // Visible only when role === 'admin'. Lists every user with their status and entitlements,
  // approves/rejects pending requests, and grants/revokes each entitlement individually.
  // `users` is normally loaded live from the database by the panel itself. It is accepted as an
  // OPTIONAL prop so the panel can be rendered from the Node verification harness (and previewed)
  // against a known list without a live Firebase connection. Passing it skips the subscription.
  var AdminPanel = function AdminPanel(_ref15) {
    var auth = _ref15.auth,
      onClose = _ref15.onClose,
      _ref15$users = _ref15.users,
      usersProp = _ref15$users === void 0 ? null : _ref15$users;
    var _window3 = window,
      Button = _window3.Button,
      Lucide = _window3.Lucide,
      Modal = _window3.Modal;
    var _useState21 = useState(usersProp),
      _useState22 = _slicedToArray(_useState21, 2),
      users = _useState22[0],
      setUsers = _useState22[1];
    var _useState23 = useState(null),
      _useState24 = _slicedToArray(_useState23, 2),
      error = _useState24[0],
      setError = _useState24[1];
    var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      busyUid = _useState26[0],
      setBusyUid = _useState26[1];
    var _useState27 = useState('all'),
      _useState28 = _slicedToArray(_useState27, 2),
      filter = _useState28[0],
      setFilter = _useState28[1];
    useEffect(function () {
      if (usersProp) return;
      if (!window.db) {
        setError('No database connection.');
        return;
      }
      var ref = window.db.ref('users');
      var handler = ref.on('value', function (snap) {
        var raw = snap.val() || {};
        var list = Object.keys(raw).map(function (uid) {
          return window.normaliseAuthProfile(uid, raw[uid], null);
        });
        list.sort(function (a, b) {
          return Number(b.createdAt || 0) - Number(a.createdAt || 0);
        });
        setUsers(list);
        setError(null);
      }, function () {
        return setError('Could not read the user list. Publish database.rules.json and make sure your own users/<uid>/role is "admin".');
      });
      return function () {
        try {
          ref.off('value', handler);
        } catch (e) {}
      };
    }, [usersProp]);
    var write = /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(uid, patch) {
        var _t1;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              if (window.db) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              setBusyUid(uid);
              _context12.p = 2;
              _context12.n = 3;
              return window.db.ref("users/".concat(uid)).update(patch);
            case 3:
              _context12.n = 5;
              break;
            case 4:
              _context12.p = 4;
              _t1 = _context12.v;
              setError('Write refused. Only an admin may change role, status or entitlements — check your own role in the console.');
            case 5:
              setBusyUid(null);
            case 6:
              return _context12.a(2);
          }
        }, _callee10, null, [[2, 4]]);
      }));
      return function write(_x1, _x10) {
        return _ref16.apply(this, arguments);
      };
    }();
    var setStatus = function setStatus(uid, status) {
      return write(uid, {
        status: status
      });
    };
    var setEntitlement = function setEntitlement(uid, key, value) {
      return write(uid, _defineProperty({}, "entitlements/".concat(key), value));
    };
    var setRole = function setRole(uid, role) {
      return write(uid, {
        role: role
      });
    };
    var shown = (users || []).filter(function (u) {
      if (filter === 'pending') return u.status === 'pending';
      if (filter === 'approved') return u.status === 'approved';
      if (filter === 'rejected') return u.status === 'rejected';
      if (filter === 'requests') return !!u.requestedAccess;
      return true;
    });
    var pendingCount = (users || []).filter(function (u) {
      return u.status === 'pending';
    }).length;
    var STATUS_STYLE = {
      approved: 'bg-emerald-950/60 border-emerald-600 text-emerald-300',
      pending: 'bg-amber-950/60 border-amber-600 text-amber-300',
      rejected: 'bg-red-950/60 border-red-600 text-red-300'
    };
    return /*#__PURE__*/React.createElement(Modal, {
      label: "Admin \u2014 users and entitlements",
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-3xl shadow-2xl max-h-[85vh] flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start mb-3"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider flex items-center gap-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "shield",
      className: "w-4 h-4 text-sky-400"
    }), " Admin \u2014 users & entitlements"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 mt-0.5"
    }, "Approve who may see restricted content, and grant each entitlement individually.", pendingCount > 0 && /*#__PURE__*/React.createElement("span", {
      className: "text-amber-300 font-bold"
    }, " ", pendingCount, " awaiting approval."))), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close admin panel",
      onClick: onClose,
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1 mb-3 flex-wrap"
    }, ['all', 'pending', 'approved', 'rejected', 'requests'].map(function (f) {
      return /*#__PURE__*/React.createElement("button", {
        key: f,
        onClick: function onClick() {
          return setFilter(f);
        },
        className: "px-3 py-1 rounded text-[10px] font-bold uppercase tracking-wider ".concat(filter === f ? 'bg-sky-600 text-white' : 'bg-slate-900 text-slate-400 hover:bg-slate-700 border border-slate-700')
      }, f);
    })), error && /*#__PURE__*/React.createElement("div", {
      className: "bg-red-950/50 border border-red-600 rounded p-2 text-[11px] text-red-200 mb-3"
    }, error), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-y-auto space-y-2 pr-1"
    }, users === null && !error && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-sm text-center py-8"
    }, "Loading users\u2026"), users !== null && shown.length === 0 && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400 text-sm text-center py-8"
    }, "No users in this view."), shown.map(function (u) {
      return /*#__PURE__*/React.createElement("div", {
        key: u.uid,
        className: "bg-slate-900 border border-slate-700 rounded p-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-wrap items-start justify-between gap-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "min-w-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-sm font-bold text-white truncate"
      }, u.displayName || '(no name)', " ", u.role === 'admin' && /*#__PURE__*/React.createElement("span", {
        className: "ml-1 text-[9px] px-1 rounded bg-sky-950 border border-sky-600 text-sky-300 uppercase font-bold"
      }, "admin")), /*#__PURE__*/React.createElement("div", {
        className: "text-[11px] text-slate-400 truncate"
      }, u.email || '(no email)'), /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-slate-400 font-mono truncate"
      }, u.uid), u.requestedAccess && /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-amber-300 mt-1"
      }, "Requested: ", Object.keys(u.requestedAccess).filter(function (k) {
        return k !== 'at' && u.requestedAccess[k];
      }).join(', ') || '—')), /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] px-2 py-0.5 rounded border uppercase font-bold tracking-wider ".concat(STATUS_STYLE[u.status] || STATUS_STYLE.pending)
      }, u.status)), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-wrap items-center gap-1 mt-2"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return setStatus(u.uid, 'approved');
        },
        disabled: busyUid === u.uid || u.status === 'approved',
        variant: "success",
        className: "h-7 px-2 text-[10px] uppercase font-bold"
      }, "Approve"), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return setStatus(u.uid, 'rejected');
        },
        disabled: busyUid === u.uid || u.status === 'rejected',
        variant: "danger",
        className: "h-7 px-2 text-[10px] uppercase font-bold"
      }, "Reject"), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return setStatus(u.uid, 'pending');
        },
        disabled: busyUid === u.uid || u.status === 'pending',
        variant: "outline",
        className: "h-7 px-2 text-[10px] uppercase font-bold"
      }, "Reset to pending"), /*#__PURE__*/React.createElement("span", {
        className: "w-px h-5 bg-slate-700 mx-1"
      }), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return setRole(u.uid, u.role === 'admin' ? 'user' : 'admin');
        },
        disabled: busyUid === u.uid || u.uid === (auth.user && auth.user.uid),
        variant: "outline",
        className: "h-7 px-2 text-[10px] uppercase font-bold",
        title: u.uid === (auth.user && auth.user.uid) ? 'You cannot change your own role — do that in the Firebase console.' : ''
      }, u.role === 'admin' ? 'Revoke admin' : 'Make admin')), /*#__PURE__*/React.createElement("div", {
        className: "mt-2 border-t border-slate-800 pt-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-[9px] uppercase tracking-widest text-slate-400 font-bold mb-1"
      }, "Entitlements"), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-wrap gap-1"
      }, ENTITLEMENT_KEYS.map(function (_ref17) {
        var key = _ref17.key,
          label = _ref17.label,
          note = _ref17.note;
        var on = u.entitlements[key] === true;
        return /*#__PURE__*/React.createElement("button", {
          key: key,
          title: note,
          disabled: busyUid === u.uid,
          onClick: function onClick() {
            return setEntitlement(u.uid, key, !on);
          },
          className: "px-2 py-1 rounded border text-[10px] font-bold ".concat(on ? 'bg-emerald-950/60 border-emerald-500 text-emerald-300' : 'bg-slate-800 border-slate-600 text-slate-400 hover:bg-slate-700')
        }, on ? '✓ ' : '', label);
      })), u.entitlements.expired && /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-amber-400 mt-1"
      }, "Entitlements have expired (expiresAt in the past).")));
    })), /*#__PURE__*/React.createElement(CourseScenarioUpload, null), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 mt-3 pt-3 text-[10px] text-slate-400"
    }, "Payments are not connected. When they are, entitlements must be written server-side from a signature-verified webhook using the Firebase Admin SDK \u2014 never from this panel or any client."), /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outline",
      className: "w-full mt-3"
    }, "Close")));
  };

  // ---- ACCOUNT PANEL -------------------------------------------------------------------------
  // Opened from the header once signed in: who you are, sign out, and (only if you want it) a
  // request for access to course scenarios. Course access is opt-in here rather than a status
  // badge in the header, because most people never need it.
  var COURSE_ACCESS_TEXT = 'Scenarios from specific courses (for example ALS, ETC and CABC) are copyrighted, so they are only released to approved course faculty and participants. Each course is approved separately.';
  // One row per course: approved, requested, or a Request button. Also used by the locked
  // Course scenarios section (data/screens/setup.js).
  var courseAccessState = function courseAccessState(auth, key) {
    var p = auth && auth.profile || {};
    if (auth && auth.has && auth.has(key)) return 'approved';
    if (p.status === 'rejected') return 'declined';
    return p.requestedAccess && p.requestedAccess[key] ? 'requested' : 'none';
  };
  var CourseAccessList = function CourseAccessList(_ref18) {
    var auth = _ref18.auth,
      _ref18$compact = _ref18.compact,
      compact = _ref18$compact === void 0 ? false : _ref18$compact;
    var _window4 = window,
      Button = _window4.Button;
    return /*#__PURE__*/React.createElement("ul", {
      className: "space-y-1.5",
      "data-testid": "course-access-list"
    }, COURSE_ACCESS.map(function (c) {
      var st = courseAccessState(auth, c.key);
      return /*#__PURE__*/React.createElement("li", {
        key: c.key,
        className: "flex flex-wrap items-center justify-between gap-2 text-xs",
        "data-testid": "course-access-".concat(c.key)
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-slate-200 font-bold"
      }, c.name), st === 'approved' ? /*#__PURE__*/React.createElement("span", {
        className: "text-emerald-300 font-bold"
      }, "Access approved") : st === 'declined' ? /*#__PURE__*/React.createElement("span", {
        className: "text-red-300"
      }, "Not approved") : st === 'requested' ? /*#__PURE__*/React.createElement("span", {
        className: "text-amber-300"
      }, "Requested, awaiting approval") : /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return auth.requestAccess(c.key);
        },
        variant: "outline",
        className: "".concat(compact ? 'h-7' : 'h-8', " px-3 text-xs text-amber-300 border-amber-500/60")
      }, "Request ", c["short"], " access"));
    }));
  };
  window.CourseAccessList = CourseAccessList;
  window.courseAccessState = courseAccessState;
  var AccountPanel = function AccountPanel(_ref19) {
    var auth = _ref19.auth,
      onClose = _ref19.onClose;
    var _window5 = window,
      Button = _window5.Button,
      Lucide = _window5.Lucide,
      Modal = _window5.Modal;
    var p = auth.profile || {};
    var anyApproved = COURSE_ACCESS.some(function (c) {
      return courseAccessState(auth, c.key) === 'approved';
    });
    return /*#__PURE__*/React.createElement(Modal, {
      label: "Your account",
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-md shadow-2xl space-y-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Your account"), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-emerald-300 mt-1 flex items-center gap-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "check-circle",
      className: "w-4 h-4"
    }), " Signed in", auth.user && auth.user.email ? /*#__PURE__*/React.createElement(React.Fragment, null, " as ", /*#__PURE__*/React.createElement("span", {
      className: "font-bold text-white"
    }, auth.user.email)) : null)), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close account panel",
      onClick: onClose,
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-300"
    }, "Your saved scenarios (My scenarios) are kept in this account and are available on any device you sign in on."), /*#__PURE__*/React.createElement("section", {
      className: "bg-slate-900 border border-slate-700 rounded p-3 space-y-2",
      "aria-labelledby": "course-access-heading"
    }, /*#__PURE__*/React.createElement("h4", {
      id: "course-access-heading",
      className: "text-sm font-bold text-white"
    }, "Course scenarios (optional)"), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400"
    }, COURSE_ACCESS_TEXT, " You only need this if you teach or attend one of those courses."), /*#__PURE__*/React.createElement(CourseAccessList, {
      auth: auth
    }), anyApproved && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-emerald-300"
    }, "Your course scenarios are in Scenario library, under Course scenarios."), p.status === 'rejected' && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-red-300"
    }, "Your request was not approved. Contact the site owner if you think this is wrong."), auth.notice && /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-emerald-300"
    }, auth.notice), auth.error && /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-red-300"
    }, auth.error)), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return auth.signOut();
            case 1:
              onClose();
            case 2:
              return _context13.a(2);
          }
        }, _callee11);
      })),
      variant: "secondary",
      disabled: auth.busy,
      className: "flex-1 h-10"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "log-out",
      className: "w-4 h-4 mr-1"
    }), " Sign out"), /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outline",
      className: "flex-1 h-10"
    }, "Close")), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 text-center"
    }, /*#__PURE__*/React.createElement("a", {
      href: "privacy.html",
      target: "_blank",
      rel: "noopener",
      className: "underline hover:text-white"
    }, "Privacy notice"), /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, " \xB7 "), /*#__PURE__*/React.createElement("a", {
      href: "delete-account.html",
      target: "_blank",
      rel: "noopener",
      className: "underline hover:text-white",
      "data-testid": "delete-account-link"
    }, "Delete my account"))));
  };

  // ---- HEADER BUTTON -------------------------------------------------------------------------
  // Sits in the controller header. It is a plain button: it never auto-opens, never nags, and
  // never gates anything. Requirement B4. Signed in, it shows the account's name and opens the
  // account panel.
  var AccountButton = function AccountButton(_ref21) {
    var auth = _ref21.auth;
    var _window6 = window,
      Button = _window6.Button,
      Lucide = _window6.Lucide;
    var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      showAuth = _useState30[0],
      setShowAuth = _useState30[1];
    var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      showAccount = _useState32[0],
      setShowAccount = _useState32[1];
    var _useState33 = useState(false),
      _useState34 = _slicedToArray(_useState33, 2),
      showAdmin = _useState34[0],
      setShowAdmin = _useState34[1];
    var signedIn = auth.phase === 'signedIn' && auth.user;
    var name = signedIn ? auth.profile && auth.profile.displayName || auth.user.displayName || auth.user.email || 'Account' : null;
    // Each box belongs to one state: signing in closes the sign-in box, signing out the
    // account panel, so neither reappears by itself on the next change.
    useEffect(function () {
      if (signedIn) setShowAuth(false);else setShowAccount(false);
    }, [!!signedIn]);
    // The one exception to "never auto-opens": back from Google in the same window with a
    // failure, the person has just asked to sign in, so show them why it did not work.
    useEffect(function () {
      if (auth.redirectFailed && !signedIn) setShowAuth(true);
    }, [!!auth.redirectFailed]);
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-1"
    }, signedIn && auth.isAdmin && /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowAdmin(true);
      },
      variant: "outline",
      className: "h-8 px-2 text-[10px] uppercase font-bold text-sky-400 border-sky-500/50"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "shield",
      className: "w-3 h-3 mr-1"
    }), " Admin"), signedIn ? /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowAccount(true);
      },
      variant: "secondary",
      ariaLabel: "Your account (".concat(name, ")"),
      className: "h-8 px-2 text-[11px] font-bold max-w-[13rem] border-emerald-700/70"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "user",
      className: "w-3 h-3 mr-1 text-emerald-300"
    }), /*#__PURE__*/React.createElement("span", {
      className: "truncate"
    }, name)) : /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowAuth(true);
      },
      variant: "secondary",
      className: "h-8 px-2 text-[10px] uppercase font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "log-in",
      className: "w-3 h-3 mr-1"
    }), /*#__PURE__*/React.createElement("span", null, "Sign in")), showAuth && !signedIn && /*#__PURE__*/React.createElement(AuthModal, {
      auth: auth,
      onClose: function onClose() {
        auth.clearFeedback();
        setShowAuth(false);
      }
    }), showAccount && signedIn && /*#__PURE__*/React.createElement(AccountPanel, {
      auth: auth,
      onClose: function onClose() {
        auth.clearFeedback();
        setShowAccount(false);
      }
    }), showAdmin && /*#__PURE__*/React.createElement(AdminPanel, {
      auth: auth,
      onClose: function onClose() {
        return setShowAdmin(false);
      }
    }));
  };
  window.AuthModal = AuthModal;
  window.AdminPanel = AdminPanel;
  window.AccountButton = AccountButton;
  window.AccountPanel = AccountPanel;
})();